const ServerAddress = 'https://essbe.etechcube.com/';
const bucket_address = 'https://prod-erp-ess.s3.ap-south-1.amazonaws.com/';
export { ServerAddress, bucket_address };

